import { Field, InputType } from 'type-graphql'
import type { IAction } from '../../action'
import { ActionArgs } from '../../action'
import { ShippingPackage } from '../ShippingPackage'
import type { ShippingGatewayProvider } from '../ShippingGatewayProvider'

@InputType()
export class GetShippingPackageArgs extends ActionArgs {
  @Field(() => String)
  labelId: string

  @Field(() => [ShippingPackage])
  packages: ShippingPackage[]

  @Field(() => String)
  gatewayProvider: ShippingGatewayProvider
}

export interface IGetShippingPackage extends IAction<ShippingPackage[], GetShippingPackageArgs> {}
